/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { Link } from 'react-router';

import scalefieldLogo from '../../assets/images/scalefield_logo.svg';
import { useNavigationHeaderStyles } from './NavigationHeader.styles';

export type NavigationHeaderProps = {
  children?: React.ReactNode;
  to?: string;
};

export function NavigationHeader(props: NavigationHeaderProps) {
  const { children, to = '/' } = props;
  const classes = useNavigationHeaderStyles();
  return (
    <div className={classes.root}>
      <Link to={to}>
        <img src={scalefieldLogo} alt="Logo" className={classes.imageLogo} />
      </Link>
      {children}
    </div>
  );
}
